import React from 'react';
import { MessageCircle, Clock, LogOut, ArrowLeft } from 'lucide-react';
import { useAuth } from '@/contexts/SupabaseAuthContext';

const TrialExpiredContactScreen = () => {
  const { signOut, user, activeAccountId, setActiveAccountId } = useAuth();
  
  const isSubaccount = activeAccountId && user && activeAccountId !== user.id;

  const whatsappNumber = '5527996208989';
  const whatsappMessage = encodeURIComponent('Quero prorrogar/assinar meu acesso no Confere Cartão.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-900 to-gray-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto">
        
        {/* Card principal */}
        <div className="bg-slate-800/80 backdrop-blur-sm border border-slate-700 rounded-2xl shadow-2xl overflow-hidden">
          
          {/* Header */}
          <div className="px-8 pt-10 pb-6 text-center">
            <div className="mx-auto mb-5 w-16 h-16 bg-amber-500/10 border border-amber-500/20 rounded-full flex items-center justify-center">
              <Clock className="w-8 h-8 text-amber-400" />
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">
              Seu período de teste expirou
            </h1>
          </div>

          {/* Corpo */}
          <div className="px-8 pb-8 space-y-6">
            
            {/* Mensagem pessoal */}
            <div className="bg-slate-700/50 border border-slate-600/50 rounded-xl p-5">
              <p className="text-slate-300 text-sm leading-relaxed">
                Caso não tenha usado ou o tempo não foi o suficiente, posso prorrogar seu acesso ou providenciar sua assinatura, fala comigo, sou o <span className="text-amber-400 font-semibold">Clevis</span>, desenvolvedor do sistema.
              </p>
            </div>

            {/* Botão WhatsApp */}
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 w-full py-4 px-6 bg-emerald-600 hover:bg-emerald-500 text-white font-semibold rounded-xl transition-all duration-200 shadow-lg shadow-emerald-600/20 hover:shadow-emerald-500/30 hover:scale-[1.02] active:scale-[0.98]"
            >
              <MessageCircle className="w-5 h-5" />
              Falar com Clevis no WhatsApp
            </a>

            {/* Botões secundários */}
            {isSubaccount ? (
              <button
                onClick={async () => {
                  localStorage.removeItem('conciliador_active_account');
                  setActiveAccountId(user.id);
                }}
                className="flex items-center justify-center gap-2 w-full py-3 text-sm text-slate-400 hover:text-white transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                Voltar para Conta Principal
              </button>
            ) : (
              <button
                onClick={async () => {
                  await signOut();
                  window.location.href = '/';
                }}
                className="flex items-center justify-center gap-2 w-full py-3 text-sm text-slate-500 hover:text-slate-300 transition-colors"
              >
                <LogOut className="w-4 h-4" />
                Sair da conta
              </button>
            )}

          </div>
        </div>

        {/* Rodapé */}
        <p className="text-center text-xs text-slate-600 mt-6">
          Confere Cartão © {new Date().getFullYear()}
        </p>

      </div>
    </div>
  );
};

export default TrialExpiredContactScreen;
